import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Modal from 'components/Modal/Modal';
import PendingView from './components/PendingView';

export const Route = createFileRoute('/_authenticated/verification/pending')({
  component: Pending,
});

function Pending() {
  const navigate = useNavigate();
  return (
    <Modal
      hideModal={() => {}}
      content={<PendingView onComplete={() => navigate({ to: '/products' })} />}
      show={true}
    />
  );
}

export default Pending;
